function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#ffa47b}.cls-5{fill:#4d4d4f}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  fill: "#f0e2db",
  d: "M4.8 0h30.4A4.8 4.8 0 0 1 40 4.8v30.4a4.8 4.8 0 0 1-4.8 4.8H4.8A4.8 4.8 0 0 1 0 35.2V4.8A4.8 4.8 0 0 1 4.8 0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "power-plant",
  transform: "translate(5.6 5.6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  d: "M6.994-4.18A.9.9 0 0 0 6.1-5h-3a.894.894 0 0 0-.9.82L1.02 14.964a.88.88 0 0 0 .314.745.91.91 0 0 0 .583.211l.214-.025 5.261-1.265a.89.89 0 0 0 .684-.932z",
  className: "cls-2",
  transform: "translate(.204 5.8)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1126",
  fill: "#f26524",
  d: "M11.064 11.7a.906.906 0 0 0-.756-.175l-8.657 1.87A2.091 2.091 0 0 0 0 15.417V19.8a2.089 2.089 0 0 0 2.1 2.07h8.4a.9.9 0 0 0 .9-.889v-8.592a.883.883 0 0 0-.336-.689z",
  transform: "translate(0 6.93)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1127",
  fill: "#ffcab2",
  d: "M6.05 17.528h-2.4a.889.889 0 1 1 0-1.778h2.4a.889.889 0 1 1 0 1.778z",
  transform: "translate(.55 7.717)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1128",
  d: "M7.3 1.778H1.9A.9.9 0 0 1 1 .889.9.9 0 0 1 1.9 0h5.4a.9.9 0 0 1 .9.889.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(.2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1129",
  d: "M26.482 9.824l-17.4-3.555a.906.906 0 0 0-.75.181.882.882 0 0 0-.332.689v14.815a.9.9 0 0 0 .9.889h16.2a2.089 2.089 0 0 0 2.1-2.074V10.694a.891.891 0 0 0-.718-.87z",
  className: "cls-2",
  transform: "translate(1.6 5.957)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2733",
  transform: "translate(13.2 18.133)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1134",
  d: "M12.5 13.62h-.6a.9.9 0 0 1-.9-.889v-.593a.9.9 0 0 1 .9-.889h.6a.9.9 0 0 1 .9.889v.593a.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(-11 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1135",
  d: "M16.5 13.62h-.6a.9.9 0 0 1-.9-.889v-.593a.9.9 0 0 1 .9-.889h.6a.9.9 0 0 1 .9.889v.593a.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(-10.2 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1136",
  d: "M20.5 13.62h-.6a.9.9 0 0 1-.9-.889v-.593a.9.9 0 0 1 .9-.889h.6a.9.9 0 0 1 .9.889v.593a.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(-9.4 -11.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1137",
  d: "M12.5 17.62h-.6a.9.9 0 0 1-.9-.889v-.593a.9.9 0 0 1 .9-.889h.6a.9.9 0 0 1 .9.889v.593a.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(-11 -10.509)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1138",
  d: "M16.5 17.62h-.6a.9.9 0 0 1-.9-.889v-.593a.9.9 0 0 1 .9-.889h.6a.9.9 0 0 1 .9.889v.593a.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(-10.2 -10.509)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1139",
  d: "M20.5 17.62h-.6a.9.9 0 0 1-.9-.889v-.593a.9.9 0 0 1 .9-.889h.6a.9.9 0 0 1 .9.889v.593a.9.9 0 0 1-.9.889z",
  className: "cls-5",
  transform: "translate(-9.4 -10.509)"
})));

function SvgColorIconsGreyManufacturers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_Manufacturers",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconsGreyManufacturers);
export default __webpack_public_path__ + "static/media/colorIconsGreyManufacturers.5a763606.svg";
export { ForwardRef as ReactComponent };